module.exports = __webpack_public_path__ + "img/oregon.38a0981e.png";